import { render, staticRenderFns } from "./topics.vue?vue&type=template&id=8bb4c9d0&"
import script from "./topics.vue?vue&type=script&lang=js&"
export * from "./topics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports